export default __webpack_public_path__ + "static/media/corporate_header_logo.ecb78f04.png";